import { render, staticRenderFns } from "./HttpForbidden.vue?vue&type=template&id=5eddacac&scoped=true"
import script from "./HttpForbidden.vue?vue&type=script&lang=js"
export * from "./HttpForbidden.vue?vue&type=script&lang=js"
import style0 from "./HttpForbidden.vue?vue&type=style&index=0&id=5eddacac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eddacac",
  null
  
)

export default component.exports